import { render, staticRenderFns } from "./TheInternalNoteDialog.vue?vue&type=template&id=4187b97a"
import script from "./TheInternalNoteDialog.vue?vue&type=script&lang=js"
export * from "./TheInternalNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./TheInternalNoteDialog.vue?vue&type=style&index=0&id=4187b97a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports